import DonationList from "../../slices/donation/DonationList";

const donationReducer = {
    donationList: DonationList,
};

export default donationReducer;